import { call, put, takeLatest } from "redux-saga/effects";
import { INITIAL_DATA } from "../actions/types";
export function* initialDataLoadWorker(action) {
  try {
    const accessToken = localStorage.getItem("accessToken");
    console.log(accessToken);
  } catch (error) {}
}

export function* initialDataLoadWatcher() {
  yield takeLatest(INITIAL_DATA, initialDataLoadWorker);
}
